import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BarberHeader from '../../components/barber/BarberHeader';

interface LocationState {
    clientDisplayName: string;
    serviceName: string;
    servicePrice: number;
    appointmentId: number;
}

const WalkInSuccessPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as LocationState;

    // Redirect if no state
    React.useEffect(() => {
        if (!state) {
            navigate('/barber/dashboard');
        }
    }, [state, navigate]);

    if (!state) {
        return null;
    }

    return (
        <>
            <BarberHeader
                title="✅ ¡Listo!"
                subtitle="Atención registrada"
                rightContent={null}
            />
            <div className="container fade-in" style={{
                maxWidth: '500px',
                margin: '0 auto',
                padding: '2rem 1rem',
                textAlign: 'center'
            }}>

                {/* Success icon */}
                <div style={{
                    fontSize: '6rem',
                    marginBottom: '1rem',
                    animation: 'pulse 1s ease-in-out'
                }}>
                    ✅
                </div>

                <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>
                    ¡Atención registrada!
                </h1>

                <p style={{ color: 'var(--text-secondary)', marginBottom: '2rem' }}>
                    El servicio ha sido agendado correctamente
                </p>

                {/* Summary card */}
                <div style={{
                    backgroundColor: 'rgba(16, 185, 129, 0.03)',
                    borderRadius: '1rem',
                    padding: '1.5rem',
                    marginBottom: '2rem',
                    border: '1px solid rgba(16, 185, 129, 0.2)',
                    textAlign: 'left',
                    color: 'var(--text-primary)'
                }}>
                    <div style={{ marginBottom: '0.75rem' }}>
                        <span style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Cliente:</span>
                        <div style={{ fontWeight: '700', fontSize: '1.2rem', marginTop: '0.25rem' }}>
                            👤 {state.clientDisplayName}
                        </div>
                    </div>

                    <div style={{ marginBottom: '0.75rem' }}>
                        <span style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Servicio:</span>
                        <div style={{ fontWeight: '700', fontSize: '1.2rem', marginTop: '0.25rem' }}>
                            ✂️ {state.serviceName}
                        </div>
                    </div>

                    <div style={{
                        borderTop: '1px solid rgba(16, 185, 129, 0.2)',
                        paddingTop: '0.75rem',
                        marginTop: '0.75rem',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <span style={{ fontWeight: '600' }}>Total:</span>
                        <span style={{ fontWeight: '800', fontSize: '1.5rem', color: 'var(--accent)' }}>
                            ${state.servicePrice.toLocaleString()}
                        </span>
                    </div>
                </div>

                <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', marginBottom: '2rem' }}>
                    📋 El servicio aparece en tu calendario y está pendiente de cobro.
                </p>

                {/* Actions */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    <button
                        onClick={() => navigate('/barber/walk-in')}
                        className="btn btn-primary"
                        style={{
                            width: '100%',
                            padding: '1rem',
                            fontSize: '1.1rem',
                            cursor: 'pointer'
                        }}
                    >
                        🚶 Atender otro cliente
                    </button>

                    <button
                        onClick={() => navigate('/barber/dashboard')}
                        className="btn btn-outline"
                        style={{
                            width: '100%',
                            padding: '1rem',
                            fontSize: '1rem',
                            cursor: 'pointer'
                        }}
                    >
                        ← Volver al Dashboard
                    </button>
                </div>
            </div>
        </>
    );
};

export default WalkInSuccessPage;
